<wre-toolkit-slideout [width]="900" [isopened]="isOpen">
    <div class="slideout-header d-flex align-items-center">
        <h3 class="slideout-title">Field Details</h3>
        <div class="slideout-options ms-auto">
            <button type="button" class="btn btn-icon" aria-label="Close" id="sidebarCloseButton"
                (click)="closeSidebar()" tabindex="-1"><i class="fal fa-times"></i>
            </button>
        </div>
    </div>
    <div class="slideout-body">
      <wre-detail-history-tab [fieldId]="fieldId"></wre-detail-history-tab>
    </div>
</wre-toolkit-slideout>
